module.exports = __webpack_public_path__ + "static/media/22.553253c8.jpg";